import React from "react";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import {withStyles} from "@material-ui/core/styles"

const styles = {
  error: {
    color: "red",
    fontSize: 12,
  },
  warning: {
    color: "orange",
    fontSize: 12
  }
}


const MaterialSelectField = ({
  classes,
  label,
  input,
  options,
  name,
  meta
}) => {
  const onChange = item => {
    input.onChange(item);
  };
  return (
    <Grid>
      <FormControl fullWidth>
        <InputLabel htmlFor="age-simple">{label}</InputLabel>
        <Select
          fullWidth
          onChange={onChange}
          inputProps={{
            name: name,
          }}
          name={name}
          value={input.value}
        >
        {options && options.map((option, i)=> <MenuItem key={i} value={option.value}>{option.label}</MenuItem>)}
        </Select>
      </FormControl>

      {meta.touched &&
        ((meta.error && <span className={classes.error}>{meta.error}</span>) ||
          (meta.warning && <span className={classes.warning}>{meta.warning}</span>))}
    </Grid>
  );
};



export default withStyles(styles)(MaterialSelectField);